// ─────────────────────────────────────────────────────────────────────
// Contrôle renforcé des produits chers / sensibles.
// Un produit est "cher" si son prix unitaire HT dépasse le seuil OU si
// son nom contient un mot-clé de la liste (VIH, onco, GLP-1…) — utile
// pour les reliquats dont le prix n'est pas synchronisé.
// Règle : photo du produit DANS LA CAISSE obligatoire avant "Prête".
// ─────────────────────────────────────────────────────────────────────

export const SEUIL_PRIX_CHER = 150; // € HT / unité

const KEYWORDS = [
  // VIH
  'BIKTARVY', 'TRIUMEQ', 'DOVATO', 'GENVOYA', 'DESCOVY', 'ODEFSEY', 'SYMTUZA', 'JULUCA', 'DELSTRIGO',
  // GLP-1 / diabète-obésité
  'MOUNJARO', 'WEGOVY', 'OZEMPIC', 'TRULICITY', 'SAXENDA', 'VICTOZA',
  // Oncologie / spécialités onéreuses
  'TAFINLAR', 'MEKINIST', 'IBRANCE', 'IMBRUVICA', 'REVLIMID', 'XTANDI', 'ZYTIGA', 'GIOTRIF', 'VERZENIOS', 'LYNPARZA', 'CALQUENCE', 'JAKAVI',
  // Biothérapies coûteuses
  'HUMIRA', 'STELARA', 'COSENTYX', 'DUPIXENT', 'SKYRIZI', 'TREMFYA', 'XOLAIR',
];

export function isProduitCher(p) {
  const price = Number(p.price_unit || 0);
  if (price >= SEUIL_PRIX_CHER) return true;
  const name = String(p.name || p.product_name || '').toUpperCase();
  return KEYWORDS.some(k => name.includes(k));
}
